import React, { useState } from "react";
import PropTypes from "prop-types";

import { Layout } from "antd";
import Grid from "./Grid";
import Header from "./Header";

import UploadFiles from "./Upload/files";
import UploadFolder from "./Upload/folder";
import Table from "./List";

const propTypes = {
    defaults: PropTypes.object.isRequired,

    currentFolderObject: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object,
    breadcrumbs: PropTypes.array,
    onChangeBreadcrumbs: PropTypes.func.isRequired,

    onUploadFile: PropTypes.func.isRequired,
    onMoveFile: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    onDeleteFile: PropTypes.func.isRequired,

    onClickFolder: PropTypes.func.isRequired,
    onCreateFolder: PropTypes.func.isRequired,
    onMoveFolder: PropTypes.func.isRequired,
    onDownloadFolder: PropTypes.func.isRequired,
    onDeleteFolder: PropTypes.func.isRequired,

    showNewFolderForm: PropTypes.func.isRequired,
    showRenameForm: PropTypes.func.isRequired,

    allowZip: PropTypes.bool.isRequired,
    allowCreate: PropTypes.bool.isRequired,
    allowRename: PropTypes.bool.isRequired,
    allowUpload: PropTypes.bool.isRequired,
    allowDelete: PropTypes.bool.isRequired,
};

const defaultProps = {
    loading: true,
    data: {},
    breadcrumbs: [],
};

const { Content } = Layout;

const App = (props) => {
    const [uploadMode, setUploadMode] = useState("none");
    const {
        defaults,

        breadcrumbs,
        onChangeBreadcrumbs,
        onClickFolder,
        onDownloadFolder,
        onDownloadFile,
        onUploadFile,
        loading,
        data,
        currentFolderObject,

        onCreateFolder,
        onDeleteFile,
        onDeleteFolder,
        onMoveFile,
        onMoveFolder,

        showNewFolderForm,
        showRenameForm,

        allowZip,
        allowCreate,
        allowUpload,
        allowRename,
        allowDelete,
    } = props;
    const [view, setView] = useState(defaults?.default_view == "grid" ? "grid" : "list");
    const colorBgContainer = "white";
    const onChangeUploadMode = (value) => {
        setUploadMode(value);
    };

    if (allowUpload && uploadMode == "files") {
        return (
            <UploadFiles
                onChangeUploadMode={onChangeUploadMode}
                onUpload={onUploadFile}
                currentFolder={currentFolderObject.fullname}
            />
        );
    }

    if (allowUpload && uploadMode == "folders") {
        return (
            <UploadFolder
                onChangeUploadMode={onChangeUploadMode}
                onUpload={onUploadFile}
                currentFolder={currentFolderObject.fullname}
            />
        );
    }

    return (
        <Content style={{ backgroundColor: "white" }}>
            <Header
                defaults={defaults}
                breadcrumbs={breadcrumbs}
                view={view}
                uploadMode={uploadMode}
                onChangeView={setView}
                onChangeUploadMode={onChangeUploadMode}
                onChangeBreadcrumbs={onChangeBreadcrumbs}
                currentFolderObject={currentFolderObject}
                showNewFolderForm={showNewFolderForm}
                showRenameForm={showRenameForm}
                allowZip={allowZip}
                allowCreate={allowCreate}
                allowUpload={allowUpload}
                onDownloadFolder={onDownloadFolder}
            />

            <Layout
                style={{
                    padding: "24px 0",
                    background: colorBgContainer,
                }}
            >
                <Content
                    style={{
                        padding: "0 24px",
                        minHeight: 280,
                        background: colorBgContainer,
                    }}
                >
                    {uploadMode === "none" && view == "grid" && (
                        <Grid
                            data={data}
                            loading={loading}
                            onUpload={onUploadFile}
                            onDeleteFile={onDeleteFile}
                            onDownloadFile={onDownloadFile}
                            onDownloadFolder={onDownloadFolder}
                            onClickFolder={onClickFolder}
                            onDeleteFolder={onDeleteFolder}
                            showNewFolderForm={showNewFolderForm}
                            showRenameForm={showRenameForm}
                            allowRename={allowRename}
                            allowDelete={allowDelete}
                            allowZip={allowZip}
                        />
                    )}
                    {uploadMode === "none" && view == "list" && (
                        <Table
                            data={data}
                            loading={loading}
                            onDownloadFile={onDownloadFile}
                            onDownloadFolder={onDownloadFolder}
                            onClickFolder={onClickFolder}
                            onMoveFile={onMoveFile}
                            onDeleteFile={onDeleteFile}
                            onMoveFolder={onMoveFolder}
                            onDeleteFolder={onDeleteFolder}
                            showNewFolderForm={showNewFolderForm}
                            showRenameForm={showRenameForm}
                            allowRename={allowRename}
                            allowDelete={allowDelete}
                            allowZip={allowZip}
                        />
                    )}
                </Content>
            </Layout>
        </Content>
    );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
